export enum DateStatus {
  NOT_AVAILABLE = 0,
  REQUESTABLE = 1,
  BOOKABLE = 2,
}
